import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { TravelerType } from '__generated__/api';

export const getTravelerTypeInput = (searchCriteria: SearchCriteriaModel): TravelerType[] | null => {
  if (searchCriteria.travelerType && searchCriteria.travelerType.length > 0) {
    return searchCriteria.travelerType
      .map(type => {
        const result = TravelerType[TravelerType[type.toUpperCase()]];

        return result ? result : null;
      })
      .filter(type => type != null);
  }

  return null;
};
